module.exports = __webpack_public_path__ + "img/right-arrow.c6b5b386.svg";